<template lang="pug">
yz-filter-menu(:label="$t('panel.claim_type')" :is-active="isActive" :display-value="displayValue" :disable-apply="!selectedType" @clear="onClear" @apply="onApply")
  template(v-slot:header)
    .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('panel.claim_type').toLowerCase() }}

  div
    yz-radio-group(v-model="selectedType" :spacing="0")
      div(v-for="(option, index) in claimTypeOptions" :key="option.value")
        .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="onSelectType(option.value)")
          yz-radio(:value="option.value" label="")
          .ml-2 {{ option.label }}
        yz-divider.my-0(v-if="index < claimTypeOptions.length - 1")
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedType: null,
      isActive: false,
      displayValue: ''
    }
  },
  computed: {
    claimTypeOptions() {
      return [
        { label: this.$t('panel.single'), value: 'single' },
        { label: this.$t('panel.bulk'), value: 'bulk' }
      ]
    }
  },
  methods: {
    onSelectType(value) {
      this.selectedType = value
    },
    onClear() {
      this.selectedType = null
      this.isActive = false
      this.displayValue = ''
      this.$emit('update:filter', {})
    },
    onApply() {
      this.isActive = true
      const option = this.claimTypeOptions.find(o => o.value === this.selectedType)
      this.displayValue = option?.label || ''

      this.$emit('update:filter', {
        key: 'type',
        value: this.selectedType
      })
    },
    reset() {
      this.onClear()
    },
    restoreFromParams(params) {
      // Restore filter state from URL params
      if (params.type) {
        this.selectedType = params.type
        this.onApply()
      }
    }
  }
}
</script>

<style scoped>
.hover-bg:hover {
  background-color: #f5f5f5;
}
</style>
